import {isEmpty} from 'lodash';
import {Http} from '@angular/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class KeyFinancialIndicatorsService {
    constructor(private http:Http) {
    }

    private keyFinancialIndicators: Array<any>;

    getKeyFinancialIndicators(): Observable<Array<any>> {
        if (isEmpty(this.keyFinancialIndicators)) {
            return this.http.get('/api/client/dictionary/key_financial_indicators')
                .map(response => response.json())
                .map(response => {
                    this.keyFinancialIndicators = response.keyFinancialIndicators;
                    return this.keyFinancialIndicators;
                });
        } else {
            return Observable.of(this.keyFinancialIndicators);
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/api/dictionaries/key.financial.indicators.service.ts